import { modules } from '@/store/modules';

const unresetableModules = [
  'brands',
  'queue',
  'healthInsurance',
  'global',
  'brandUnit',
  'payments',
  'registrationData',
  'questionnaire',
];

const resetStates = ({ commit }) => {
  Object.keys(modules).forEach((moduleName) => {
    if (!unresetableModules.includes(moduleName)) {
      commit(`SET_CLEAR_${moduleName.toUpperCase()}`);
    }
  });
};

export default resetStates;
